import { getCookie } from 'cookies';
import { DNT_STORAGE_NAME } from './config';

const isDoNotTrack = () => !!getCookie(DNT_STORAGE_NAME);

export default isDoNotTrack;
